import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import {
  AppointmentDetailsEntryPoint,
  useSetCalendarAppointmentInfoAsSelected,
} from '../stores/schedule-appointment-info-panel.store';

type UseGetAppointmentDetailsProps = {
  appointmentId: string;
  locationId: string;
  appointments?: Appointment[];
  onModalClose?: () => void;
  entryPoint?: AppointmentDetailsEntryPoint;
};

export const useGetAppointmentDetails = ({
  appointmentId,
  locationId,
  onModalClose,
  appointments,
  entryPoint = 'schedule',
}: UseGetAppointmentDetailsProps) => {
  const apptPanelInfo = useSetCalendarAppointmentInfoAsSelected(appointmentId, locationId, appointments, entryPoint);

  const handleCloseModal = () => {
    onModalClose?.();
    apptPanelInfo.resetSelection();
  };

  return {
    openModal: () => apptPanelInfo.setAppointment(),
    closeModal: handleCloseModal,
    isSelected: apptPanelInfo.isSelected,
  };
};
